import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export default function useSetData(
    data: IManagementAddNewLoanExtends[] | undefined,
    setData: React.Dispatch<
        React.SetStateAction<IManagementAddNewLoanExtends[] | undefined>
    >,
    mutate: (body: IManagementBodyValidate) => void
) {
    const { state } = useLocation()
    const [amount, setAmount] = useState<number | undefined>()
    const [date, setDate] = useState<undefined | string>()
    useEffect(() => {
        if (!data) {
            const newData: Array<IManagementAddNewLoanExtends> = []
            if (state && state?.response && state?.response?.installments) {
                state?.response?.installments.map((item) =>
                    newData.push({ ...item, isSelected: false })
                )
                setData(newData)
            }
        }
    }, [state])

    const handleSelect = (index: number) => {
        const newData: Array<IManagementAddNewLoanExtends> = []
        data?.map((item) => {
            if (item.index === index) {
                newData.push({ ...item, isSelected: !item.isSelected })
                setAmount(item.amount)
            } else {
                newData.push({ ...item, isSelected: false })
            }
        })
        setData(newData)
    }
    const handleSetSelect = (index: number) => {
        const newData: Array<IManagementAddNewLoanExtends> = []
        data?.map((item) => {
            if (item.index === index) {
                newData.push({
                    ...item,
                    isSelected: false,
                    amount: amount ? Number(amount) : item.amount,
                    due_date: date ? date : item.due_date,
                })
            } else {
                newData.push({ ...item, isSelected: false })
            }
        })
        setData(newData)
    }
    const handleMutate = () => {
        if (data) {
            const newData: IInstallment[] = []
            data.map((item) =>
                newData.push({
                    index: item.index,
                    amount: item.amount,
                    due_date: item.due_date,
                })
            )
            const body: IManagementBodyValidate = {
                amount: state?.payload.amount,
                interest_pay_mode: state?.payload?.interest_pay_mode,
                interest_type: state?.payload?.interest_type,
                interest_rate: state?.payload?.interest_rate,
                fixed_interest_amount: state?.payload?.fixed_interest_amount,
                installments: newData,
            }
            mutate(body)
        }
    }
    return {
        handleSelect,
        amount,
        setAmount,
        date,
        setDate,
        handleSetSelect,
        handleMutate,
    }
}
